import styled from "styled-components";
import { colors } from "../../components/common/element/elements";

export const Styles = styled.div`

    h6 {
        color        : ${colors.bg3};
        overflow    : hidden;
        display     : -webkit-box;
        -webkit-line-clamp: 1;
                line-clamp: 1; 
        -webkit-box-orient: vertical;
    }
`;